import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import ServiceDetailHero from '../components/ServiceDetailHero';
import ServiceDetailContent from '../components/ServiceDetailContent';
import ServiceDetailFeatures from '../components/ServiceDetailFeatures';
import ServiceDetailProcess from '../components/ServiceDetailProcess';
import ServiceDetailPricing from '../components/ServiceDetailPricing';
import CTASection from '../../home/components/CTASection';
import { useSEO } from '../../../utils/seo';

const DigitalAdsPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Meta & Google Ads Yönetimi - Sigorta360 | Dijital Reklam Hizmeti',
    description: 'Sigorta acenteleri için Meta (Facebook & Instagram) ve Google Ads reklam yönetimi. ROI odaklı kampanyalar, düşük lead maliyeti, yüksek dönüşüm. 9.000₺\'den başlayan paketler.',
    keywords: 'sigorta google ads, sigorta facebook reklam, meta ads yönetimi, sigorta dijital reklam, lead üretimi',
    canonical: `${siteUrl}/hizmetler/dijital-reklamcilik`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Meta & Google Ads Yönetimi',
      description: 'Sigorta sektörüne özel dijital reklam yönetimi ve kampanya optimizasyonu',
      provider: {
        '@type': 'Organization',
        name: 'Sigorta360',
        url: siteUrl
      },
      areaServed: {
        '@type': 'Country',
        name: 'Türkiye'
      },
      offers: {
        '@type': 'AggregateOffer',
        priceCurrency: 'TRY',
        lowPrice: '9000',
        highPrice: '18000',
        offerCount: '3'
      }
    }
  });

  const heroData = {
    category: 'Dijital Reklamcılık',
    title: 'Meta & Google Ads Yönetimi',
    description: 'Hedef kitleye özel kampanyalarla lead maliyetlerinizi düşürüyor, dönüşüm oranlarınızı artırıyoruz. ROI odaklı reklam stratejileri ile bütçenizi en verimli şekilde kullanın.',
    image: 'https://public.readdy.ai/ai/img_res/4db2271544acebde34c2fcd30f2b3782.jpg',
  };

  const contentData = {
    overview: 'Dijital reklamcılık, sigorta acenteleri için en hızlı lead üretme yöntemlerinden biridir. Meta (Facebook & Instagram) ve Google Ads platformlarında uzman ekibimizle, hedef kitlenize doğrudan ulaşıyor, ölçülebilir sonuçlar elde ediyoruz.',
    benefits: [
      {
        icon: 'ri-funds-line',
        title: 'Düşük Lead Maliyeti',
        description: 'Optimize edilmiş kampanyalarla lead başına maliyetinizi %40\'a kadar düşürün.',
      },
      {
        icon: 'ri-target-line',
        title: 'Hedefli Erişim',
        description: 'Demografik, coğrafi ve davranışsal hedefleme ile doğru kişilere ulaşın.',
      },
      {
        icon: 'ri-line-chart-line',
        title: 'Yüksek Dönüşüm',
        description: 'A/B testleri ve sürekli optimizasyon ile dönüşüm oranlarınızı artırın.',
      },
      {
        icon: 'ri-pie-chart-line',
        title: 'Ölçülebilir Sonuçlar',
        description: 'Her harcanan kuruşun karşılığını detaylı raporlarla takip edin.',
      },
    ],
  };

  const featuresData = {
    title: 'Reklam Yönetimi Hizmetlerimiz',
    features: [
      {
        icon: 'ri-search-eye-line',
        title: 'Hedef Kitle Analizi',
        description: 'Detaylı pazar araştırması, müşteri persona oluşturma, davranışsal analiz, rakip hedef kitle incelemesi.',
      },
      {
        icon: 'ri-lightbulb-line',
        title: 'Kampanya Stratejisi',
        description: 'Bütçe planlaması, platform seçimi, kampanya yapısı oluşturma, KPI belirleme.',
      },
      {
        icon: 'ri-image-add-line',
        title: 'Reklam Kreatifi',
        description: 'Göz alıcı görsel tasarımlar, etkili reklam metinleri, video reklamlar, carousel reklamlar.',
      },
      {
        icon: 'ri-settings-3-line',
        title: 'Kampanya Optimizasyonu',
        description: 'Günlük performans takibi, bütçe optimizasyonu, hedef kitle iyileştirme, teklif stratejisi.',
      },
      {
        icon: 'ri-test-tube-line',
        title: 'A/B Testing',
        description: 'Görsel testleri, metin testleri, hedef kitle testleri, landing page testleri.',
      },
      {
        icon: 'ri-file-chart-line',
        title: 'Detaylı Raporlama',
        description: 'Haftalık performans raporları, ROI analizi, dönüşüm takibi, strateji önerileri.',
      },
    ],
  };

  const processData = {
    title: 'Reklam Yönetimi Sürecimiz',
    steps: [
      {
        number: '01',
        title: 'Keşif & Planlama',
        description: 'İş hedeflerinizi anlama, hedef kitle belirleme, bütçe planlama, platform seçimi.',
      },
      {
        number: '02',
        title: 'Kampanya Kurulumu',
        description: 'Hesap yapılandırması, piksel kurulumu, dönüşüm takibi, kampanya yapısı oluşturma.',
      },
      {
        number: '03',
        title: 'Kreatif Üretimi',
        description: 'Reklam görselleri tasarlama, metin yazarlığı, video üretimi, landing page hazırlama.',
      },
      {
        number: '04',
        title: 'Yayınlama & İzleme',
        description: 'Kampanya başlatma, günlük performans takibi, anlık optimizasyonlar, sorun giderme.',
      },
      {
        number: '05',
        title: 'Analiz & Raporlama',
        description: 'Performans analizi, ROI hesaplama, strateji iyileştirme, gelecek planlaması.',
      },
    ],
  };

  const pricingData = {
    title: 'Meta & Google Reklam Yönetimi Paketleri',
    packages: [
      {
        name: 'Başlangıç',
        price: '9.000',
        period: 'ay',
        description: 'Temel reklam yönetimi ve optimizasyon',
        features: [
          '1 Kampanya yönetimi',
          'Reklam kurulumu ve hedef kitle belirleme',
          'Temel optimizasyon çalışmaları',
          'Temel performans analizi',
          'Aylık raporlama',
          'E-posta desteği',
        ],
        highlighted: false,
      },
      {
        name: 'Profesyonel',
        price: '13.500',
        period: 'ay',
        description: 'Satış ve dönüşüm odaklı yönetim',
        features: [
          '3 Kampanya yönetimi',
          'Facebook Pixel ve Google Analytics kurulumu',
          'Haftalık optimizasyon çalışmaları',
          'Satış ve e-ticaret dönüşüm optimizasyonu',
          'Veri izleme altyapısı kurulumu',
          'Haftalık performans raporu',
          'A/B test çalışmaları',
        ],
        highlighted: true,
      },
      {
        name: 'Premium',
        price: '18.000',
        period: 'ay',
        description: 'ROI odaklı tam kapsamlı yönetim',
        features: [
          'Çoklu kampanya yönetimi',
          'Dönüşüm odaklı optimizasyon',
          'Sürekli kreatif üretim ve test',
          'ROI ve performans odaklı yönetim',
          'Gelişmiş hedef kitle segmentasyonu',
          'Remarketing kampanyaları',
          'Detaylı analiz ve strateji raporları',
          'Özel hesap yöneticisi',
        ],
        highlighted: false,
      },
    ],
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ServiceDetailHero data={heroData} />
        <ServiceDetailContent data={contentData} />
        <ServiceDetailFeatures data={featuresData} />
        <ServiceDetailProcess data={processData} />
        <ServiceDetailPricing data={pricingData} />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default DigitalAdsPage;
